export default __webpack_public_path__ + "static/9-e424ea1bdab346373a95907175ce273c.jpg";